export default __webpack_public_path__ + "static/media/mapa.7c7a2963.jpg";